import React from 'react';
import { useTranslation } from 'react-i18next';
import { /*CardRow,*/ Section } from '@weezevent/nacre';
import Style from './marketingPromotion.module.css';
import { ReactComponent as CrownLogo } from '../../../../images/marketing/premium-crown.svg';

export default function MarketingPromotion({ organization }) {
    const { t } = useTranslation();

    if (!organization || !organization.business_entity?.informations) {
        return null;
    }
    return (
        <>
            <Section className={Style['promotion-section']}>
                <div style={{ fontWeight: 'bold' }}>
                    <span className={Style['crown-icon']}>
                        <CrownLogo />
                    </span>
                    {t('ticket.ticket_design.create_design.promotion.title')}
                </div>
                <div className={Style['promotion-content']}>
                    <div>{t('ticket.ticket_design.create_design.promotion.description')}</div>
                    <div className={Style['contact-link']}>
                        <a href={`mailto:${organization.business_entity.informations.mailto}`}>{t('ticket.creationEvent.help.titleContact')}</a>
                    </div>
                </div>
            </Section>

            {/* Todo: Need marketing images with a better quality */}

            {/* <div className={Style['promotional-images']}>
                <CardRow>
                    <CardRow.LeftComponent>
                    </CardRow.LeftComponent>
                    <CardRow.LeftComponent>
                    </CardRow.LeftComponent>
                    <CardRow.LeftComponent>
                    </CardRow.LeftComponent>
                    <CardRow.LeftComponent>
                    </CardRow.LeftComponent>
                </CardRow>
            </div> */}
        </>
    );
}
